import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { ObjektNutzungsService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [ObjektNutzungsService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class ObjektNutzungsServiceModule {}
